// extracted by mini-css-extract-plugin
module.exports = {"container":"TitleLabel_container__bhBgg","label":"TitleLabel_label__1Le6i","campaignfalse":"TitleLabel_campaignfalse__2-9qd","hovercheck":"TitleLabel_hovercheck__2sQF3"};